const getEnvList = () => {
    return process.env.REACT_APP_ENV_NAME_LIST?.split(',') || [''];
};

const getSogEnvList = () => {
    return process.env.REACT_APP_SOG_ENV_LIST?.split(',') || [''];
};


const getAPIBaseRoute = () => {
    return process.env.REACT_APP_ENV_API_LIST?.split(',')[Number(localStorage.getItem('env') || '0')];
};

const getSoGAPIBaseRoute = () => {
    return process.env.REACT_APP_SOGAPI_URLS?.split(',')[Number(localStorage.getItem('sog_env') || '0')];
};

const getSelectedEnv = () => {
    return process.env.REACT_APP_ENV_NAME_LIST?.split(',')[Number(localStorage.getItem('env') || '0')];
};

const getSelectedSoGEnv = () => {
    return process.env.REACT_APP_SOG_ENV_LIST?.split(',')[Number(localStorage.getItem('sog_env') || '0')];
};


const getAPIRoute = () => {
    return getAPIBaseRoute() + "api/v1/";
};


export {getAPIRoute, getEnvList, getSelectedEnv, getSogEnvList, getSelectedSoGEnv, getSoGAPIBaseRoute};
